import { clsxMerge } from '@dreamstack/util'
import { Css_Text_16_24_tw } from '../layout/Texts'

// Class constants
export const StyledNewsTypeWrapper_tw = 'flex'
export const StyledNewsType_tw =
  'bg-accentroGray-full text-accentroWhite-full px-px-12 py-px-8 font-semibold'
export const StyledNewsTypeTranslated_tw =
  'bg-accentroGray-full text-accentroWhite-full px-px-12 py-px-8 transform -translate-y-1/2 font-semibold'
export const StyledNewsDate_base_tw = clsxMerge(
  Css_Text_16_24_tw,
  'font-semibold'
)
export const StyledNewsDate_light_tw = 'text-accentroWhite-full'
export const StyledNewsDate_dark_tw = 'text-accentroGray-full'

// Functional components
export const StyledNewsTypeWrapper = (
  props: React.HTMLAttributes<HTMLDivElement>
) => (
  <div
    {...props}
    className={clsxMerge(StyledNewsTypeWrapper_tw, props.className)}
  />
)
export const StyledNewsType = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={clsxMerge(StyledNewsType_tw, props.className)} />
)
export const StyledNewsTypeTranslated = (
  props: React.HTMLAttributes<HTMLDivElement>
) => (
  <div
    {...props}
    className={clsxMerge(StyledNewsTypeTranslated_tw, props.className)}
  />
)
export const StyledNewsDate = ({
  light,
  className,
  ...rest
}: { light?: boolean } & React.HTMLAttributes<HTMLDivElement>) => (
  <div
    {...rest}
    className={clsxMerge(
      StyledNewsDate_base_tw,
      light ? StyledNewsDate_light_tw : StyledNewsDate_dark_tw,
      className
    )}
  />
)
